/**
 * Test IDs for QA automation.
 */
export const testIds = {
  readingsFileConfigurationFormTankIdColumn: "readings-file-configuration-form-tank-id-column",
  readingsFileConfigurationFormDateColumn: "readings-file-configuration-form-date-column",
  readingsFileConfigurationFormDateFormat: "readings-file-configuration-form-date-format",
  readingsFileConfigurationFormTimeColumn: "readings-file-configuration-form-time-column",
  readingsFileConfigurationFormTimeFormat: "readings-file-configuration-form-time-format",
  readingsFileConfigurationFormLevelColumn: "readings-file-configuration-form-level-column",
  readingsFileConfigurationFormStoreColumn: "readings-file-configuration-form-store-column",
} as const;
